import { render, staticRenderFns } from "./VoucherForm.vue?vue&type=template&id=68ccb022"
import script from "./VoucherForm.vue?vue&type=script&lang=js"
export * from "./VoucherForm.vue?vue&type=script&lang=js"
import style0 from "./VoucherForm.vue?vue&type=style&index=0&id=68ccb022&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports